<template>
  <v-footer id="pages-core-footer" color="transparent" absolute dark>
    <v-container fluid class="pa-0">
      <v-row align="center" no-gutters>
        <div style="background-color:#313131; min-height:10px;  width :100%;" class="d-flex flex-column justify-space-between align-center">
          <v-img :aspect-ratio="68/27" :src="require(`@/assets/${'LogoRusoft.png'}`)" width="120px" />
        </div>
      </v-row>
      <div style="background-color:#ac8a2a; min-height:10px;  width :100%" />
      <v-row align="start" justify="center" style="background-color:#181818;">
        <v-col md="5">
          <span style="color:#d9a734;"><strong>Reconocidos por:</strong></span>
          <v-row>
            <v-col class="d-flex child-flex">
              <v-img :aspect-ratio="59/49" :src="require(`@/assets/${'fifa.png'}`)" max-width="90px" />
              <v-img :aspect-ratio="89/98" :src="require(`@/assets/${'afa.png'}`)" max-width="90px" />
              <v-img :aspect-ratio="107/98" :src="require(`@/assets/${'uefa.png'}`)" max-width="90px" />
              <v-img :aspect-ratio="1/1" :src="require(`@/assets/${'conmebol.jpg'}`)" max-width="90px" />
            </v-col>
          </v-row>
        </v-col>
        <v-col md="5">
          <span style="color:#d9a734;"><strong>Contacto</strong></span>
          <p style="color:#FFF">
            <span style="font-weight:900; color:#d9a734;">+</span> info@prisports.com<br>
            <span style="font-weight:900; color:#d9a734;">+</span> (011) 2072-3723<br>
            <span style="font-weight:900; color:#d9a734;">+</span> Monroe 5382 Piso 11 of. B (C1431CAV) C.A.B.A . Argentina.
          </p>
        </v-col>
        <v-col align-self="center" cols="auto">
          <v-img src="https://micuenta.donweb.com/img/sectigo_positive_md.png" max-width="140px" />
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'PagesCoreFooter',

    data: () => ({
    }),
  }
</script>

<style lang="sass">
  #pages-core-footer
    a
      color: #FFFFFF
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
